"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var helpers_1 = require("./helpers");
var styles_1 = require("./styles");
function IllustratedMessage(_a) {
    var illustration = _a.illustration, illustrationConfigs = _a.illustrationConfigs, header = _a.header, headerStyle = _a.headerStyle, body = _a.body, bodyStyle = _a.bodyStyle, mainContainerStyle = _a.mainContainerStyle;
    return (react_1.default.createElement(styles_1.MainContainer, { style: mainContainerStyle },
        illustration &&
            (react_1.default.isValidElement(illustration)
                ? illustration
                : helpers_1.getIllustrationToRender(illustration, illustrationConfigs)),
        header &&
            (typeof header === "string" ? (react_1.default.createElement(styles_1.Header, { style: headerStyle }, header)) : (header)),
        body &&
            (typeof body === "string" ? (react_1.default.createElement(styles_1.Paragraph, { style: bodyStyle }, body)) : (body))));
}
exports.default = IllustratedMessage;
//# sourceMappingURL=index.js.map